
import ConstantsHosters from '../utils/constantsByConfig.js';
/**
 * Enum for user types.
 * @readonly
 * @enum {number}
 */
export const UserTypesEnum = {
    UNKNOWN: 0,
    USER: 1,
    COOP_TECHNICIAN: 2,
    SUPER_ADMIN: 4,
  };

export const UserTypesHelper = {

  //Obtient le role en fonction du userType de l'utilisateur uniquement connecté.
  //Rôle qui sera affiché dans productfruit
    getRoleByUserType(userType) {

      if (this.hasType(userType, UserTypesEnum.SUPER_ADMIN)) {
        return 'Super admin';
      }
      else if (this.hasType(userType, UserTypesEnum.COOP_TECHNICIAN)) {
        return 'Technicien';
      }
      else if (this.hasType(userType, UserTypesEnum.USER)) {
        return 'Agriculteur';
      }
      else {
        return 'Inconnu';
      }

    },

    //Donne un libellé pour le username dans productfruit en fonction du type utilisateur.
    //un TC qui se connecte : ex : DEV_userId-TC
    //un agri simple (utilisateur simple) qui se connecte : ex : DEV_userId-clientId
    //un super admin qui se connecte : ex : DEV_userId-SA
    // un utilisateur dont on ne connait pas le type utilisateur : ex : DEV_userId-
    giveProductfruitUsername(userType, userId, clientId) {

      if (this.hasType(userType, UserTypesEnum.SUPER_ADMIN)) {
        return `${ConstantsHosters.onboardingPrefix}${userId}-SA`;
      }
      else if (this.hasType(userType, UserTypesEnum.COOP_TECHNICIAN)) {
        return `${ConstantsHosters.onboardingPrefix}${userId}-TC`;
      }
      else if (this.hasType(userType, UserTypesEnum.USER)) {
        return `${ConstantsHosters.onboardingPrefix}${userId}-${(clientId > 0) ? clientId : ""}`;
      }
      else {
        return `${ConstantsHosters.onboardingPrefix}${userId}-`;
      }

    },

    /**
     * demande si un userType possède bien userTypeToCompare
     * @param {*} userTypeGiven userType de l'utilisateur fournit à React
     * @param {*} userTypeToCompare userTypeEnum avec lequel on compare
     * @returns boolean
     */
    hasType(userTypeGiven, userTypeToCompare) {
      const result = (userTypeGiven & userTypeToCompare) === userTypeToCompare;
      return result;
    }

};